onDomReady(() => {
   for (const select of document.querySelectorAll('.filterSelectField')) {
      select.addEventListener('change', function () {
         window.location = this.value;
      });
   }
});
